import { PkgWarehouse } from '@/api/user-package/types/UserPkg'
import { cn } from '@/lib/utils'

import greeceFlagCircle from '../imgs/flags/greece-circle.png'
import turkeyFlagCircle from '../imgs/flags/turkey-circle.png'
import uaeFlagCircle from '../imgs/flags/uae-circle.png'
import ukFlagCircle from '../imgs/flags/uk-circle.png'
import usaFlagCircle from '../imgs/flags/usa-circle.png'

const warehouseToLogo = {
  [PkgWarehouse.GR]: greeceFlagCircle,
  [PkgWarehouse.USA]: usaFlagCircle,
  [PkgWarehouse.UK]: ukFlagCircle,
  [PkgWarehouse.TR]: turkeyFlagCircle,
  [PkgWarehouse.UAE]: uaeFlagCircle,
}
export const warehouseToLabel = {
  [PkgWarehouse.GR]: 'יוון',
  [PkgWarehouse.USA]: 'ארה״ב',
  [PkgWarehouse.UK]: 'אנגליה',
  [PkgWarehouse.TR]: 'טורקיה',
  [PkgWarehouse.UAE]: 'איחוד האמירויות',
}
interface Props {
  warehouse: PkgWarehouse
  includeLabel?: boolean
  className?: string
  containerClassName?: string
}
export const WarehousePreview = ({ warehouse, includeLabel, className, containerClassName }: Props) => {
  return (
    <div className={cn('flex items-center gap-2', containerClassName)}>
      <img src={warehouseToLogo[warehouse]} alt={warehouse} className={cn('size-4', className)} />
      {includeLabel && <span className='text-sm'>{warehouseToLabel[warehouse]}</span>}
    </div>
  )
}
